import { Injectable, signal, computed } from "@angular/core";
import { BehaviorSubject, firstValueFrom } from "rxjs";

import { StepState } from "./models/step.model";
import { DirectApiService } from "./directApi.service";

@Injectable({
  providedIn: 'root',
})
export class StepService {
  
  private _stepsView = signal<StepState[]>([]);
  public stepsViewSignal = computed(() => this._stepsView());
  get stepsViewSignalValue(): StepState[] {
    if(this._stepsView().length === 0){
      this.initSteps();
    }
    return this._stepsView();
  }
  public SetStepsView(steps: StepState[]) {
    this._stepsView.set(steps);
  };

  stateChangeSubject = new BehaviorSubject<boolean>(false);
  $stateChange = this.stateChangeSubject.asObservable();

  constructor(
    public directApiService: DirectApiService,
    // public sessionLocalStorageService: SessionLocalStorageService
  ){

  }

  
  async initSteps() {
    try{
      const response = await firstValueFrom( await this.directApiService.fetchSteps() );
      this.SetStepsView(response as StepState[]);
    }
    catch(e) {
      console.error("Error fetching steps: ", e);
      this.SetStepsView([]);
    }

  }

  async getStepFromUrl(url: string): Promise<StepState> {
    //get step where url matches step url
    
    let stepToReturn = this.stepsViewSignalValue.find(step => step.urlRef === url)!;
    return stepToReturn;
  }

}
